export default "__VITE_ASSET__CGt3yam9__"